import { css } from 'styled-components';

export const brandSpecificNavBorderStyle = css`
  border-top: 1px solid #ddd;
  box-shadow: 0px -5px 30px -20px rgba(0, 0, 0, 0.75);
`;
